require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-zambia-country-forest-note-is-it-a-sustainable-roadmap.json") })
        }
      }, "path---en-us-update-zambia-country-forest-note-is-it-a-sustainable-roadmap");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-zambia-country-forest-note-is-it-a-sustainable-roadmap!./.cache/json/en-us-update-zambia-country-forest-note-is-it-a-sustainable-roadmap.json
// module id = 878
// module chunks = 231608221292675